const LANGUAGE = {
  EN: 'en',
  TH: 'th'
} as const

const FETCH_STATUS = {
  IDLE: 'idle',
  PENDING: 'pending',
  SUCCESS: 'success',
  ERROR: 'error'
}

const DEFAULT_IMAGE_PATH = {
  AVARTAR: '/images/contents/avatar-default.png',
}

const NODE_FLOW = {
  NODE_TYPE_LIST: ['agent', 'action', '__end__', 'custom', 'http']
}

export const DATA = {
  LANGUAGE,
  FETCH_STATUS,
  DEFAULT_IMAGE_PATH,
  NODE_FLOW
};

export type ILANGUAGE = (typeof LANGUAGE)[keyof typeof LANGUAGE]
